import { observer } from 'mobx-react-lite'
import { Divider, Typography } from 'shared/ui'
import { useInboxLayerContext } from 'pages/settings/pages/inboxes/context/inboxLayerContext'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import styles from './styles.module.scss'

export const CallingGeneral = observer(() => {
  const {
    inboxSettingsStore: { callingGeneralStore },
  } = useInboxLayerContext()
  const {
    useOrgCallSettings,
    toggleUseOrgCallSettings,
    outboundCalls,
    toggleOutboundCalls,
    inboundCalls,
    toggleInboundCalls,
    conferenceCalling,
    callTranscription,
    outboundCallsAircall,
    toggleOutboundCallsAircall,
    isCallSettingsDisabled,
    isConferenceAndTranscriptionDisabled,
    toggleConferenceCalling,
    toggleCallTranscription,
    isShowOutboundCallsAircall,
  } = callingGeneralStore

  return (
    <div className={styles.wrap}>
      <Typography
        ariaLabel={'CallingGeneralTitle'}
        variant={'body-lg-medium'}
        marginBottom={'24px'}
      >
        General
      </Typography>
      <DoubleOptInSettingLayout
        title={'Use organization settings'}
        description={'Mirror organization calling settings for this inbox'}
        checked={useOrgCallSettings}
        onToggle={toggleUseOrgCallSettings}
      />
      <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
      <DoubleOptInSettingLayout
        title={'Outbound calls'}
        description={'Enable outbound calls for this inbox'}
        checked={outboundCalls}
        onToggle={toggleOutboundCalls}
        disabled={isCallSettingsDisabled}
      />
      <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
      {isShowOutboundCallsAircall && (
        <>
          <DoubleOptInSettingLayout
            title={'Open outbound calls via Aircall'}
            description={'All outbound calls will be opened by Aircall app'}
            checked={outboundCallsAircall}
            onToggle={toggleOutboundCallsAircall}
            disabled={isCallSettingsDisabled}
          />
          <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
        </>
      )}
      <DoubleOptInSettingLayout
        title={'Inbound calls'}
        description={'Enable inbound calls for this inbox'}
        checked={inboundCalls}
        onToggle={toggleInboundCalls}
        disabled={isCallSettingsDisabled}
      />
      <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
      <DoubleOptInSettingLayout
        title={'Conference calling'}
        description={'Enable conference calls for this inbox'}
        checked={conferenceCalling}
        onToggle={toggleConferenceCalling}
        disabled={isConferenceAndTranscriptionDisabled}
      />
      <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
      <DoubleOptInSettingLayout
        title={'Call transcription'}
        description={'Transcribe your voicemails and call recordings'}
        checked={callTranscription}
        onToggle={toggleCallTranscription}
        disabled={isConferenceAndTranscriptionDisabled}
      />
    </div>
  )
})
